import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

export function ContactsGuard({ children }: { children: React.ReactNode }) {
  const user = useAuthStore((s) => s.user);
  if (!user) return <Navigate to="/" replace />;
  // Contractors pass with the flag too; the backend limits them to the
  // branches picked in contacts_branches.
  const allowed =
    user.is_ceo ||
    user.role === "director" ||
    user.role === "coordinator" ||
    user.has_contacts_access;
  if (!allowed) return <Navigate to="/" replace />;
  return <>{children}</>;
}
